import { Controller } from "@hotwired/stimulus"

// Shows the "content" target while the checkbox is checked:
//   div data-controller="reveal"
//     input type="checkbox" data-action="change->reveal#toggle" data-reveal-target="checkbox"
//     div data-reveal-target="content"
export default class extends Controller {
  static targets = ["checkbox", "content"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.contentTarget.hidden = !this.checkboxTarget.checked
  }
}
